var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.computedBackgroundColor })},[(_vm.isLogged && !_vm.loading)?_c('div',[_c('Navbar',{attrs:{"MenuItems":_vm.MenuItems}}),(false)?_c('Notification'):_vm._e()],1):_vm._e(),(_vm.isLogged)?_c('Appbar'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }